"use strict";
exports.__esModule = true;
function Spring(initialPosition, _a) {
    if (initialPosition === void 0) { initialPosition = 0; }
    var _b = _a === void 0 ? {} : _a, _c = _b.stiffness, stiffness = _c === void 0 ? 200 : _c, _d = _b.damping, damping = _d === void 0 ? 10 : _d, _e = _b.precision, precision = _e === void 0 ? 100 : _e;
    var position = initialPosition;
    var endPosition = 0;
    var secPerFrame = 1 / 60;
    var velocity = 0;
    var onUpdate = function (v) { };
    var onRest = function (v) { };
    var raf;
    var interpolate = function () {
        var distance = endPosition - position;
        var acceleration = stiffness * distance - damping * velocity;
        var newVelocity = velocity + acceleration * secPerFrame;
        var newPosition = position + newVelocity * secPerFrame;
        var isComplete = Math.abs(newVelocity) < 1 / precision &&
            Math.abs(newPosition - endPosition) < 1 / precision;
        position = isComplete ? endPosition : newPosition;
        velocity = newVelocity;
        onUpdate(position);
        if (!isComplete)
            raf = requestAnimationFrame(interpolate);
        else
            onRest(position);
    };
    return {
        setValue: function (v) {
            if (v === void 0) { v = 0; }
            cancelAnimationFrame(raf);
            position = endPosition = v;
            onUpdate(position);
        },
        transitionTo: function (v) {
            if (v === void 0) { v = 0; }
            cancelAnimationFrame(raf);
            endPosition = v;
            raf = requestAnimationFrame(interpolate);
        },
        onUpdate: function (fn) {
            if (fn === void 0) { fn = function (v) { }; }
            onUpdate = fn;
            fn(position);
        },
        onRest: function (fn) {
            if (fn === void 0) { fn = function (v) { }; }
            onRest = fn;
        },
        destroy: function () {
            cancelAnimationFrame(raf);
            onUpdate = function () { };
            onRest = function () { };
        }
    };
}
exports["default"] = Spring;
